import { render, staticRenderFns } from "./Components0.vue?vue&type=template&id=d60e1a96&scoped=true"
import script from "./Components0.vue?vue&type=script&lang=js"
export * from "./Components0.vue?vue&type=script&lang=js"
import style0 from "./Components0.vue?vue&type=style&index=0&id=d60e1a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60e1a96",
  null
  
)

export default component.exports